import { normalizeConditionName } from './skinConditionNormalization';
import { isSkinConditionName } from './skinResultsUtils';

export const SCORE_KEY_TO_CONCERN = {
  hydration: 'Hydration',
  oxygen: 'Oxygen',
  smoothness: 'Smoothness',
  dullness: 'Dullness',
  uneven_skintone: 'UnevenSkin',
};

const VIEW_ORDER = ['front', 'left', 'right'];

export function findBestViewForConcern(detectionsByView = {}, concernName) {
  const target = normalizeConditionName(concernName);
  if (!target) return 'front';

  if (isSkinConditionName(target)) return 'front';

  let bestView = 'front';
  let bestConf = -1;
  VIEW_ORDER.forEach((view) => {
    (detectionsByView[view] || []).forEach((det) => {
      const name = normalizeConditionName(det?.class_name || det?.className || '');
      if (name !== target) return;
      const confRaw = det?.confidence ?? det?.score ?? 0;
      const conf = confRaw <= 1 ? confRaw * 100 : confRaw;
      if (conf > bestConf) {
        bestConf = conf;
        bestView = view;
      }
    });
  });
  return bestView;
}

export function scoreKeyToConcern(scoreKey) {
  return SCORE_KEY_TO_CONCERN[scoreKey] || null;
}
